import { FC } from 'react';
import { motion } from 'framer-motion';

interface AnimatedLineProps {
  duration?: number;
  direction?: 'right' | 'left';
  delay?: number;
}

export const AnimatedLine: FC<AnimatedLineProps> = ({
  duration = 1.5,
  direction = 'right',
  delay = 0,
}) => (
  <motion.div
    initial={{ scaleX: 0 }}
    animate={{ scaleX: 1 }}
    transition={{ duration, ease: 'easeInOut', delay }}
    className="white-line"
    style={{
      transformOrigin: direction,
    }}
  />
);
